module.exports = __webpack_public_path__ + "static/media/income-calc.5b08bdf4.svg";